import { SocketEvent } from '../types/SocketEvent';

export function decodeChatGatewayEventData(
  event: SocketEvent,
  raw: unknown,
): unknown {
  switch (event) {
    case SocketEvent.NewMsg:
      if (typeof raw !== 'string') return null;
      return (JSON.parse(raw) as { data?: unknown })?.data ?? null;
    default:
      return null;
  }
}
